import { RoundButton } from '../../../components/round-button/round-button';
import React, { PropsWithChildren } from 'react';
import styles from './back-button.module.scss';

export const BackButton = ({ children }: PropsWithChildren) => {
  return (
    <RoundButton className={styles.button} theme="primary">
      {children}
    </RoundButton>
  );
};
